.cta {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  margin-top: 1.5rem;
  border-radius: 2rem;
  padding: 1rem 4rem;
  text-decoration: none;
  color: var(--color-white);
  background-color: var(--section-color);
  font-size: 1.1rem;
  font-weight: 500;
  justify-content: center;
  align-self: flex-start;
  justify-self: end;
  width: 100%;

  @media (prefers-color-scheme: dark) {
    color: var(--color-foreground);
    background: linear-gradient(
      to right,
      var(--section-color-dark),
      var(--section-color-light)
    );
  }

  @media (min-width: 30rem) {
    width: auto;
  }

  @media (min-width: 64rem) {
    padding: 0.8rem 2.4rem;
  }
}

.cta:hover::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -25%;
  width: 150%;
  height: 200%;
  background: linear-gradient(
    -45deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 2s infinite;

  // Dropping the sweep rather than freezing it: with the animation off the
  // gradient parks over the button as a permanent white smear.
  @media (prefers-reduced-motion: reduce) {
    content: none;
  }
}

@keyframes shimmer {
  from {
    transform: translateX(-100%);
  }
  50%,
  to {
    transform: translateX(100%);
  }
}
